import { List, ListItem, ListItemText, Typography, Box, Paper } from '@mui/material';
import moment from 'moment';

interface ListComponentProps {
  data: any[];
  handleRedirect: (id: string) => void;
  maxHeight?: string | number; // Permite customizar a altura máxima
}

export function ListComponent({ data, handleRedirect, maxHeight = 'calc(100vh - 280px)' }: ListComponentProps) {
  const url = window.location.href;
  
  return (
    <Paper elevation={0} sx={{ 
      borderRadius: 2,
      overflow: 'hidden',
      border: '1px solid #f0f0f0',
      maxWidth: 800,
      width: '100%',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: maxHeight,
    }}>
      {/* Header fixo */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        padding: '12px 20px',
        backgroundColor: '#fafafa',
        borderBottom: '1px solid #f0f0f0',
        flexShrink: 0, // Impede que o header encolha
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }}>
        <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>Nome</Typography>
        <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>{url.includes('usuarios') ? 'Acesso' : 'Descrição'}</Typography>
        {url.includes('clientes') && <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>Plano</Typography>}
        {url.includes('clientes') && <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>Data inicial</Typography> } 
        {url.includes('clientes') && <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>Data final</Typography>}
      </Box>
      
      {/* Body com scroll */}
      <Box sx={{
        flex: 1,
        overflowY: 'auto',
        // Scrollbar customizada
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#4db0b1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#3a8d8e',
        },
      }}>
        <List disablePadding>
          {data.map((item, index) => (
            <ListItem 
              key={item.id || index}
              onClick={() => handleRedirect(item.id)} 
              sx={{ 
                display: 'flex',
                padding: '12px 20px',
                borderBottom: index < data.length - 1 ? '1px solid #f0f0f0' : 'none',
                transition: 'background-color 0.2s',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.03)',
                  cursor: 'pointer',
                }
              }}
            >
              <ListItemText 
                primary={<Typography variant="body2" noWrap>{item.name}</Typography>}
                sx={{ flex: 1, margin: 0 }}
              />
              <ListItemText 
                primary={<Typography variant="body2" noWrap>{url.includes('usuarios') ? item?.role?.name : item?.description}</Typography>}
                sx={{ flex: 1, margin: 0 }}
              />
              {url.includes('clientes') && <ListItemText 
                primary={<Typography variant="body2" noWrap>{item?.plan?.name}</Typography>}
                sx={{ flex: 1, margin: 0 }}
              />}
              {url.includes('clientes') && 
              <ListItemText 
                primary={
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {item.planInitialDate ? moment(item.planInitialDate).format('DD/MM/YYYY') : moment(item.createdAt).format('DD/MM/YYYY')}
                  </Typography>
                }
                sx={{ flex: 1, margin: 0}}
              />}
              {url.includes('clientes') && 
              <ListItemText 
                primary={
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                     {item.planDueDate ? moment(item.planDueDate).format('DD/MM/YYYY') : '-'}
                  </Typography>
                }
                sx={{ flex: 1, margin: 0}}
              />}
            </ListItem>
          ))}
          
          {data.length === 0 && (
            <ListItem sx={{ padding: '16px', justifyContent: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                Nenhum item encontrado
              </Typography>
            </ListItem>
          )}
        </List>
      </Box>
    </Paper>
  );
}